export default __webpack_public_path__ + "static/Winter Illustration-d4aa7055bc7f08c9e5a725bb9a71d7df.png";